import { EnumHelpers as EnumHelpersBase } from "core-kit";
import { IDropDownItem } from "../models";

export class EnumHelpers extends EnumHelpersBase {
  static getDropDownList<T extends EnumType>(enumType: T, labelFn: (x: keyof T) => string = (x) => x.toString()): IDropDownItem<keyof T>[] {
    const enumKeys = this.getKeys(enumType);
    return enumKeys.map((x) => ({ value: x, label: labelFn(x) }));
  }
}

export type EnumType = Record<string, string | number>;
